import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "3b389893-d127-4e29-8a22-0c8d568221f8",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "652d485f-ba17-4010-bbee-68e83f339b84",
      type: "Sprite",
      name: "slot",
      nameSpace: "",
      className: "house",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "Polygon",
        path: "-150,30, 140,-65, 140,260, -40,120, -150,30"
      },
      texture: "base_texture",
      parent: "3b389893-d127-4e29-8a22-0c8d568221f8",
      data: ""
    },
    {
      id: "ad0b8644-256a-4eff-b65e-dc0ebcaf70a5",
      type: "Container",
      name: "itemContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "652d485f-ba17-4010-bbee-68e83f339b84",
      data: ""
    },
    {
      id: "cb9fef5e-06c8-4bf5-b7b3-f50c6856dd60",
      type: "Container",
      name: "taskIcon",
      nameSpace: "",
      className: "",
      x: 0,
      y: 110,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "652d485f-ba17-4010-bbee-68e83f339b84",
      data: ""
    },
    {
      id: "9a0ff8f5-1822-47c4-a43e-a48baa214d8a",
      type: "Container",
      name: "replyTaskIcon",
      nameSpace: "",
      className: "",
      x: 0,
      y: 110,
      scale: {
        x: 0.75,
        y: 0.75
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "652d485f-ba17-4010-bbee-68e83f339b84",
      data: ""
    },
    {
      id: "04a9727e-fd7d-45f3-bc36-f4709592ea64",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_bg",
      parent: "cb9fef5e-06c8-4bf5-b7b3-f50c6856dd60",
      data: ""
    },
    {
      id: "8d59743c-39e3-4631-a638-766a51f192d4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_bg",
      parent: "9a0ff8f5-1822-47c4-a43e-a48baa214d8a",
      data: ""
    },
    {
      id: "66f34045-5342-4fb0-8847-c125d11961de",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -1,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_house",
      parent: "04a9727e-fd7d-45f3-bc36-f4709592ea64",
      data: ""
    },
    {
      id: "37ae5f92-8342-4133-93f4-94a8d820f58b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -1,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task_house",
      parent: "8d59743c-39e3-4631-a638-766a51f192d4",
      data: ""
    },
    {
      id: "84b07a24-4ff6-4784-a753-762375dc8b16",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 25,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "reply_task",
      parent: "8d59743c-39e3-4631-a638-766a51f192d4",
      data: ""
    }
  ]
} as const;

export class HouseSlotLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  slot: GameObject<PIXI.Sprite>;
  itemContainer: GameObject<PIXI.Container>;
  taskIcon: GameObject<PIXI.Container>;
  replyTaskIcon: GameObject<PIXI.Container>;
  house: (GameObject<PIXI.Sprite>)[];

  constructor() {
    populate(this, raw);
  }
}
